import { useLazyFetchWhoAmIQuery, WhoAmI } from "../../app/whoAmIApi"
import { useEffect } from "react"
import { useParams } from "react-router-dom"

export const useWhoAmIQueryOnParamsChange = (callback: (data: WhoAmI) => void): void => {
  const params = useParams()
  const [fetch] = useLazyFetchWhoAmIQuery()

  useEffect(() => {
    // preferCacheValue: hent whoami én gang og gjenbruk svaret ved senere param-endringer
    void fetch(undefined, true).unwrap().then(callback)
  }, [params])
}
